import { Injectable } from '@angular/core';

import { BannerDocs, BannerOrigin, BannersMap } from '@interfaces/banners';
import { FirebaseService } from '../firebase/firebase.service';

@Injectable({
  providedIn: 'root',
})
export class BannersService {
  bannersMap: BannersMap;

  constructor(
    private firebaseService: FirebaseService,
  ) {
    this.bannersMap = {
      withdrawalError: {
        showInHome: false,
        showInMovements: false,
        metadata: {},
      },
    };
  }

  isBannerVisible(bannerName: string, origin: string = BannerOrigin.home): boolean {
    if (origin === BannerOrigin.movements) {
      return this.bannersMap[bannerName].showInMovements;
    }
    return this.bannersMap[bannerName].showInHome;
  }

  async shouldShowWithdrawalErrorBanner(origin: string, userId: string): Promise<boolean> {
    const withdrawalErrorBannerDoc = await this.getWithdrawalErrorBannerDoc(userId);

    this.bannersMap.withdrawalError.metadata.withdrawalsIds = withdrawalErrorBannerDoc && withdrawalErrorBannerDoc.withdrawalsIds;
    if (origin === BannerOrigin.movements) {
      this.bannersMap.withdrawalError.showInMovements = withdrawalErrorBannerDoc && withdrawalErrorBannerDoc.showInMovements;
      this.bannersMap.withdrawalError.showInMovements && this.firebaseService.logEvent('show_withdrawal_error_banner_mov', {});
      return this.bannersMap.withdrawalError.showInMovements;
    }

    this.bannersMap.withdrawalError.showInHome = withdrawalErrorBannerDoc && withdrawalErrorBannerDoc.showInHome;
    this.bannersMap.withdrawalError.showInHome && this.firebaseService.logEvent(`show_withdrawal_error_banner_home`, {});
    return this.bannersMap.withdrawalError.showInHome;
  }

  async updateUserWithdrawalErrorNotificationDoc(origin: string, userId: string): Promise<void> {
    const originAttribute = origin === BannerOrigin.movements ? 'showInMovements' : 'showInHome';
    if (!this.bannersMap.withdrawalError[originAttribute]) { return; }

    try {
      const notificationsCollection = this.firebaseService.getCollection(`users/${userId}/notifications`);
      const updateData = {
        updatedAt: new Date(),
        ...(origin === BannerOrigin.movements && { showInMovements: false }),
        ...(origin === BannerOrigin.home && { showInHome: false }),
      };
      await this.firebaseService.updateDocument(updateData, notificationsCollection, BannerDocs.withdrawalErrorBanner);
      this.firebaseService.logEvent(`hide_withdrawal_error_banner_${origin}`, {});
    } catch (error) {
      return Promise.resolve();
    } finally {
      this.bannersMap.withdrawalError[originAttribute] = false;
    }
  }

  private async getWithdrawalErrorBannerDoc(userId: string) {
    const notificationsCollection = this.firebaseService.getCollection(`users/${userId}/notifications`);
    const withdrawalErrorBannerDoc = await this.firebaseService.getDocument(BannerDocs.withdrawalErrorBanner, notificationsCollection);
    return withdrawalErrorBannerDoc;
  }
}
